"use strict";

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _hooks = require("../hooks");

var _utilities = require("../utilities");

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function Persist(_ref) {
  var store = _ref.store;
  var state = (0, _hooks.useTreble)();

  var _useTreble = (0, _hooks.useTreble)(),
      _useTreble2 = _slicedToArray(_useTreble, 2);

  _objectDestructuringEmpty(_useTreble2[0]);

  var dispatch = _useTreble2[1]; //set to local storage

  var setLocalStorage = function setLocalStorage(store, state) {
    if (typeof Storage !== "undefined") {
      store.forEach(function (item) {
        var _item$features;

        var persist = (_item$features = item.features) === null || _item$features === void 0 ? void 0 : _item$features.persist;
        var key = Object.keys(item.state)[0];

        if (persist === true) {
          var value = state[0][key];
          localStorage.setItem(key, value);
        } else {
          localStorage.removeItem(key);
        }
      });
    }
  }; //update state based on local storage


  var updateStateFromLocalStorage = function updateStateFromLocalStorage(store, state) {
    if (typeof Storage !== "undefined") {
      store.forEach(function (item, index) {
        var _item$features2;

        var persist = (_item$features2 = item.features) === null || _item$features2 === void 0 ? void 0 : _item$features2.persist;

        if (persist === true) {
          var _key = Object.keys(item.state)[0];

          var value = localStorage.getItem(_key) || state[0][_key];

          var action = item.action;
          (0, _utilities.updateStore)(action, value, dispatch);
        }
      });
    }
  };

  (0, _react.useEffect)(function () {
    updateStateFromLocalStorage(store, state);
  }, [dispatch]);
  (0, _react.useEffect)(function () {
    setLocalStorage(store, state);
  }, [state]);
  return null;
}

var _default = Persist;
exports["default"] = _default;
module.exports = exports["default"];